// cleancode-ui/src/components/ReviewStatus.jsx
import React from 'react';
import './ReviewStatus.css';

const ReviewStatus = ({ reviewStatus }) => {
  if (!reviewStatus) {
    return (
      <div className="review-status-container">
        <div className="review-status-loading">
          <div className="loading-spinner"></div>
          <span>Loading review status...</span>
        </div>
      </div>
    );
  }

  const getStatusColor = () => {
    if (!reviewStatus) return '#6B7280';
    
    if (reviewStatus.percentage >= 90) return '#EF4444'; // Red
    if (reviewStatus.percentage >= 75) return '#F59E0B'; // Yellow
    return '#10B981'; // Green
  };

  const getStatusMessage = () => {
    if (!reviewStatus) return '';
    
    if (reviewStatus.limit === 'unlimited') {
      return 'Unlimited reviews available';
    }
    
    if (reviewStatus.remaining === 0) {
      return 'Monthly review limit reached';
    }
    
    if (reviewStatus.remaining === 1) {
      return '1 review remaining this month';
    }
    
    return `${reviewStatus.remaining} reviews remaining this month`;
  };

  const getPlanDisplayName = (planName) => {
    if (!planName || planName === 'trial') return 'Trial';
    return planName.charAt(0).toUpperCase() + planName.slice(1);
  };

  return (
    <div className="review-status-container">
      <div className="review-status-header">
        <h3>Monthly Review Status</h3>
        <span className="plan-badge">{getPlanDisplayName(reviewStatus.plan_name)}</span>
      </div>
      
      <div className="review-status-content">
        {reviewStatus.limit === 'unlimited' ? (
          <div className="unlimited-status">
            <div className="unlimited-icon">♾️</div>
            <span>Unlimited reviews</span>
          </div>
        ) : (
          <>
            <div className="progress-container">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ 
                    width: `${reviewStatus.percentage}%`,
                    backgroundColor: getStatusColor()
                  }}
                ></div>
              </div>
              <div className="progress-text">
                {reviewStatus.current_count} / {reviewStatus.limit}
              </div>
            </div>
            
            <div className="status-message">
              {getStatusMessage()}
            </div>
          </>
        )}
        
        {!reviewStatus.allowed && reviewStatus.limit !== 'unlimited' && (
          <div className="limit-reached">
            <div className="limit-warning">
              <span>🚫 Monthly limit reached</span>
            </div>
          </div>
        )}
        
        {reviewStatus.remaining <= 2 && reviewStatus.remaining > 0 && reviewStatus.limit !== 'unlimited' && (
          <div className="limit-warning-message">
            <span>⚠️ Running low on reviews</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewStatus;